import { render, staticRenderFns } from "./DeliveryMap.vue?vue&type=template&id=80f6ad18&scoped=true&lang=pug&"
import script from "./DeliveryMap.vue?vue&type=script&lang=js&"
export * from "./DeliveryMap.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryMap.vue?vue&type=style&index=0&id=80f6ad18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f6ad18",
  null
  
)

export default component.exports